import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import PublisherEditor from "@/pages/publisher/PublisherEditor";

export const Route = createFileRoute("/publisher/$id")({
  head: () => pageHead("Publisher \u2014 Id \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: () => <PublisherEditor mode="edit" />,
});
